import {Chart, Legend, Title, Tooltip } from "chart.js"

Chart.register(Legend, Title, Tooltip)